import { Injectable } from '@angular/core';
import * as libphonenumber from 'google-libphonenumber';
import { CountryData } from '../model';
import { HttpClient } from '@angular/common/http';
import { writeLog, writeError } from '../misc/logs';

@Injectable({
  providedIn: 'root'
})
export class MiscService {
  PNF = libphonenumber.PhoneNumberFormat;

  constructor(
    private http: HttpClient,
  ) {}

  getCountryList() {
    return this.http.get<CountryData[]>('assets/countries.json');
  }

  validateCountryPhone(country: CountryData, phoneNumber: string) {
      const pNumber = this.getCountryPhone(country, phoneNumber);
      return (pNumber != null);
  }

  getCountryPhone(country: CountryData, phoneNumber: string) {
    try {
      const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
      const pNumber = phoneUtil.parseAndKeepRawInput(phoneNumber, country.countryCode);
      writeLog('pNumber', pNumber);

      return (phoneUtil.isValidNumber(pNumber)) ? pNumber : null;
    } catch (e) {
      // writeLog(e);
      return null;
    }
  }

  formatCountryPhone(countryCode: string, phoneNumber: string): string {
    try {
      const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
      const pNumber = phoneUtil.parseAndKeepRawInput(phoneNumber, countryCode);
      return phoneUtil.format(pNumber, this.PNF.E164);
    } catch (e) {
      // writeLog(e);
      return '';
    }
  }

  checkMobile(mobileNo: string): boolean {
    const regexp = new RegExp(/^0\d{9}$/);
    if (regexp.test(mobileNo)) {
      return true;
    }

    const regexp2 = new RegExp(/^\+?\d{12}$/);
    return regexp2.test(mobileNo);
  }

  trimMobile(mobileNo: string): string {
    return !mobileNo
      ? ''
      : mobileNo
          .toString()
          .trim()
          .replace(/[^0-9]/g, '');
          // .replace(' ', '')
          // .replace('-', '');
  }

  // correctMobile(mobileNo: string): string {
  //   const regexp = new RegExp(/^0\d{9}$/);
  //   if (regexp.test(mobileNo)) {
  //     // append country code
  //     return this.countryCode + mobileNo.substr(1);
  //   }

  //   const regexp2 = new RegExp(/^\d{12}$/);
  //   if (regexp2.test(mobileNo)) {
  //     return '+' + mobileNo;
  //   }

  //   return mobileNo;
  // }

  softEncrypt(numbers: string) {
    let output = '';
    numbers = numbers.substr(1);
    for (let i = 0; i < numbers.length; i++) {
      output = output + this.num2char(+numbers[i]);
    }
    return output;
  }

  softDecrypt(encrypted: string) {
    let output = '';
    for (let i = 0; i < encrypted.length; i++) {
      output = output + this.char2num(encrypted[i]);
    }
    return '+' + output;
  }

  num2char(num: number) {
    switch (num) {
      case 0:
        return 'z';
      case 1:
        return 'a';
      case 2:
        return 'r';
      case 3:
        return 'w';
      case 4:
        return 'm';
      case 5:
        return 'x';
      case 6:
        return 'i';
      case 7:
        return 'l';
      case 8:
        return 'c';
      case 9:
        return 'u';
    }
  }

  char2num(char: string) {
    switch (char) {
      case 'z':
        return 0;
      case 'a':
        return 1;
      case 'r':
        return 2;
      case 'w':
        return 3;
      case 'm':
        return 4;
      case 'x':
        return 5;
      case 'i':
        return 6;
      case 'l':
        return 7;
      case 'c':
        return 8;
      case 'u':
        return 9;
    }
  }
}
